<template>
    <div>
        <button @click="toggleActive" class="text-teal-600" tabindex="-1">
            <slot />
            <i class="fad mr-1" :class="loading == 'toggleActive' ? 'fa-spinner fa-spin' : active ? 'fa-toggle-on' : 'text-teal-400 fa-toggle-off'"></i>
        </button>
    </div>
</template>

<script>
import Helpers from "@/admin/Mixins/GeneralHelpers.js";

export default {
    props: {
        url: String,
        active: Boolean
    },
    mixins: [Helpers],
    methods: {
        toggleActive() {
            this.loading = "toggleActive";
            this.$inertia
                .patch(this.url, null, {
                    preserveState: true,
                    preserveScroll: true
                })
                .then(() => (this.loading = ""));
        }
    }
};
</script>
